import { defineMessages } from 'react-intl'

export default defineMessages({
    send: {
        defaultMessage: 'Solicita información',
    },
    success: {
        defaultMessage: 'Hemos recibido tus datos correctamente. En breve uno de nuestros comerciales se pondrá en contacto contigo.',
    },
    error: {
        defaultMessage: 'Ha sucedido un error. Inténtelo más tarde.',
    },
    header: {
        defaultMessage: 'Rellena el formulario y pronto contactaremos contigo.',
    },
})
